(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zentein-collection-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zentein-collection-purchase')) {
  class ZenteinCollectionPurchase extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('zentein-quantity');
      this.button = this.querySelector('[data-zcp-add]');
      this.status = this.querySelector('[data-zcp-status]');
      this.strings = JSON.parse(this.querySelector('[data-zcp-strings]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-zcp-variants]').textContent);
      const on = (node, name, fn) => node?.addEventListener(name, fn, {signal:this.abort.signal});
      on(this.form, 'submit', event => this.submit(event));
      on(this, 'change', event => {
        if (event.target.matches('[data-zq-proxy]')) this.render();
      });
      on(this.querySelector('[data-zcp-variant]'), 'change', event => {
        const variant = this.variants.find(v => String(v.id) === event.target.value);
        if (!variant || !this.quantity.setVariant) return;
        this.form.elements.id.value = String(variant.id);
        this.quantity.setVariant(variant);
        this.status.textContent = '';
      });
      customElements.whenDefined('zentein-quantity').then(() => {
        if (!this.isConnected) return;
        this.dataset.ready = 'true';
        this.render();
      });
    }
    disconnectedCallback() { this.abort?.abort();this.abort = null;delete this.dataset.ready; }
    render() {
      const q = this.quantity;
      if (!q.rules || !window.ZenteinCartRules) return;
      const rate = q.rate(), prices = window.ZenteinCartRules.quantityPrice(q.base, q.quantity, rate);
      this.querySelector('[data-zcp-original]').textContent = q.quantity + ' × ' + q.money(q.base);
      this.querySelector('[data-zcp-discount]').textContent = rate ? this.strings.discount.replace('{percent}', rate).replace('{amount}', q.money(prices.saving)) : '';
      this.querySelector('[data-zcp-total]').textContent = this.strings.total + ' ' + q.money(prices.total);
      const unavailable = q.disabled || q.max < q.min;
      this.button.disabled = Boolean(this.busy || unavailable);
      this.querySelector('fieldset').disabled = Boolean(this.busy);
      const selector = this.querySelector('[data-zcp-variant]');
      if (selector) selector.disabled = Boolean(this.busy);
      const label = q.disabled ? this.strings.soldOut : unavailable ? this.strings.limit : this.strings.add.replace('{quantity}', q.quantity).replace('{total}', q.money(prices.total));
      this.button.textContent = this.busy ? this.strings.adding : label;
      this.button.setAttribute('aria-label', (this.busy ? this.strings.adding : label) + ' · ' + this.dataset.title);
    }
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || !this.quantity.commit || !this.quantity.commit() || this.quantity.max < this.quantity.min || this.quantity.disabled) return;
      const count = this.quantity.quantity;
      const data = new FormData(this.form);
      this.busy = true;this.status.textContent = '';this.status.dataset.error = 'false';this.render();
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:data});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || this.strings.error);
        this.status.textContent = this.strings.added.replace('{quantity}', count);
        if (!window.ZenteinCart) window.location.assign(this.dataset.root + 'cart');
      } catch (error) {
        this.status.dataset.error = 'true';
        this.status.textContent = error.message || this.strings.error;
      } finally { this.busy = false;this.render(); }
    }
  }
  customElements.define('zentein-collection-purchase', ZenteinCollectionPurchase);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zentein-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zentein-quantity')) {
  class ZenteinQuantity extends HTMLElement {
    static rate(quantity, rules) { return window.ZenteinCartRules.quantityRate(quantity, rules); }
    static parse(value, min, max, step) {
      const text = String(value).trim();
      if (!/^\d+$/.test(text)) return null;
      const q = Number(text);
      return Number.isSafeInteger(q) && q >= min && q <= max && (q - min) % step === 0 ? q : null;
    }
    static price(base, quantity, rate) {
      return window.ZenteinCartRules.quantityPrice(base, quantity, rate);
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.input = this.querySelector('[data-zq-input]');
      this.proxy = this.querySelector('[data-zq-proxy]');
      this.strings = JSON.parse(this.querySelector('[data-zq-strings]').textContent);
      this.min = Number(this.dataset.min) || 1;
      this.step = Number(this.dataset.step) || 1;
      this.base = Number(this.dataset.basePrice);
      this.max = Math.min(Number(this.dataset.max) || Infinity, Math.floor(Number.MAX_SAFE_INTEGER / Math.max(1, this.base)));
      this.ruleMax = this.max;
      this.quantity = this.min;
      this.committed = this.min;
      this.cartCount = 0;
      this.unlocked = new Set();
      this.disabled = this.input.disabled;
      this.form = document.getElementById(this.dataset.formId);
      this.root = this.closest('[data-pdp2-root],[data-elite2-root],[data-c2hero-root]');
      const config = document.getElementById('ZenteinCartConfig');
      this.rules = JSON.parse(config.textContent).rules;
      this.ids = new Set(this.rules.eligibleProductIds);
      this.eligible = this.ids.has(this.dataset.productId);
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency', currencyDisplay:'narrowSymbol', currency:this.dataset.currency});
      const on = (node, event, fn, extra = {}) => node?.addEventListener(event, fn, {...extra, signal:this.abort.signal});
      on(this.input, 'input', () => {
        const q = this.read();
        if (q !== null) { this.quantity = q; this.error(''); this.render(); }
      });
      on(this.input, 'change', () => this.commit());
      on(this.input, 'blur', () => this.commit());
      on(this.input, 'keydown', e => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); this.change(e.key === 'ArrowUp' ? 1 : -1); }
        if (e.key === 'Enter') { e.preventDefault(); this.commit(); }
      });
      on(this.querySelector('[data-zq-minus]'), 'click', () => this.change(-1));
      on(this.querySelector('[data-zq-plus]'), 'click', () => this.change(1));
      on(this.form, 'submit', e => {
        if (this.closest('[hidden]')) return;
        if (this.read() === null) { e.preventDefault(); e.stopImmediatePropagation(); this.commit(); this.input.focus(); }
      }, {capture:true});
      on(document, 'zentein:cart:confirmed', e => this.cart(e.detail.cart));
      const initial = document.getElementById('ZenteinInitialCart');
      // Deferred purchase scripts attach their compatibility listeners at DOM ready.
      // The shared cart rules are deferred too; wait for all deferred scripts before
      // reading initial cart quantities or synchronizing the purchase listeners.
      const start = () => {
        if (!this.isConnected || !window.ZenteinCartRules) return;
        if (initial) this.cart(JSON.parse(initial.textContent), false);
        this.render(); this.unlocked.add(this.rate());
      };
      on(document, 'DOMContentLoaded', () => requestAnimationFrame(start), {once:true});
      if (document.readyState === 'complete' || window.ZenteinCartRules) requestAnimationFrame(start);
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    money(cents) { return this.format.format(cents / 100); }
    read() { return ZenteinQuantity.parse(this.input.value, this.min, this.max, this.step); }
    rate() { return this.eligible ? ZenteinQuantity.rate(this.quantity + this.cartCount, this.rules) : 0; }
    cart(cart, update = true) {
      this.currentCart = cart;
      this.cartCount = window.ZenteinCartRules.eligibleQuantity(cart, this.rules);
      if (this.dataset.inventory !== '') {
        const already = (cart.items || []).filter(l => String(l.variant_id) === this.dataset.variantId).reduce((sum,l) => sum + Number(l.quantity), 0);
        this.max = Math.max(0, Math.min(this.ruleMax, Number(this.dataset.inventory) - already));
        this.input.setAttribute('aria-valuemax', this.max);
        if (this.quantity > this.max && this.max >= this.min) {
          this.quantity = this.min + Math.floor((this.max - this.min) / this.step) * this.step;
          this.input.value = String(this.quantity);
          this.error(this.strings.limit);
        }
      }
      if (update) this.render();
    }
    setVariant(variant) {
      this.dataset.variantId = String(variant.id);
      this.dataset.inventory = variant.inventory == null ? '' : String(variant.inventory);
      this.base = Number(variant.price);
      this.min = Number(variant.min) || 1;
      this.step = Number(variant.step) || 1;
      this.ruleMax = Math.min(Number(variant.max) || Infinity, Math.floor(Number.MAX_SAFE_INTEGER / Math.max(1, this.base)));
      this.max = this.ruleMax;
      if (Number.isFinite(this.max)) this.input.setAttribute('aria-valuemax', this.max);
      else this.input.removeAttribute('aria-valuemax');
      this.disabled = !variant.available;
      this.input.disabled = this.disabled;
      this.input.setAttribute('aria-valuemin', this.min);
      this.quantity = this.min;
      this.committed = this.min;
      this.input.value = String(this.min);
      this.error('');
      this.cart(this.currentCart || {items:[]}, false);
      this.render();
    }
    error(message) {
      const node = this.querySelector('[data-zq-error]');
      node.textContent = message; node.hidden = !message;
      this.input.setAttribute('aria-invalid', String(Boolean(message)));
    }
    commit() {
      const q = this.read();
      if (q === null) {
        this.input.value = String(this.quantity);
        this.error(this.strings.invalid.replace('{min}', this.min).replace('{step}', this.step));
        return false;
      }
      const previous = this.committed;
      this.quantity = q; this.committed = q; this.input.value = String(q); this.error(''); this.render();
      if (q !== previous) {
        this.event('quantity_changed', previous);
        const tier = this.rate();
        if (tier > ZenteinQuantity.rate(previous + this.cartCount, this.rules) && !this.unlocked.has(tier) && this.event('quantity_tier_unlocked', previous)) this.unlocked.add(tier);
      }
      return true;
    }
    change(direction) {
      const next = Math.max(this.min, Math.min(this.max, this.quantity + direction * this.step));
      if (next < this.min || this.disabled) return;
      this.input.value = String(next); this.commit();
    }
    event(name, previous) {
      if (this.dataset.designMode === 'true' || new URLSearchParams(location.search).has('social_qa') || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish !== 'function') return false;
        publish.call(window.Shopify.analytics, name, {product_id:this.dataset.productId,variant_id:this.dataset.variantId,quantity:this.quantity,previous_quantity:previous,discount_tier:this.rate()})?.catch?.(() => {});
        return true;
      } catch { return false; }
    }
    render() {
      const q = this.quantity, rate = this.rate(), prices = ZenteinQuantity.price(this.base, q, rate), pieces = Number(this.dataset.pieces) || 1;
      const each = this.money(Math.round(prices.total / q)), perPiece = this.money(Math.round(prices.total / (q * pieces)));
      this.querySelector('[data-zq-unit-price]').textContent = each + '/' + this.dataset.unit;
      this.querySelector('[data-zq-saving]').textContent = rate ? this.strings.save.replace('{amount}', this.money(prices.saving)).replace('{percent}', rate) : this.strings.regular;
      this.querySelector('[data-zq-tiers]').hidden = !this.eligible;
      this.querySelectorAll('[data-zq-tier]').forEach(node => node.setAttribute('aria-current', String(Number(node.dataset.zqTier) === (rate === 15 ? 5 : rate === 10 ? 3 : rate === 5 ? 2 : 0))));
      const count = q + this.cartCount, next = count < 2 ? 2 : count < 3 ? 3 : 5;
      this.querySelector('[data-zq-next]').textContent = !this.eligible ? '' : this.cartCount > 0 ? this.strings.cart.replace('{percent}', rate) : rate === 15 ? this.strings.best : this.strings.next.replace('{quantity}', next - count).replace('{percent}', ZenteinQuantity.rate(next, this.rules));
      this.input.setAttribute('aria-valuenow', q);
      this.querySelector('[data-zq-minus]').disabled = this.disabled || q <= this.min;
      this.querySelector('[data-zq-plus]').disabled = this.disabled || q + this.step > this.max;
      this.proxy.value = String(q);
      Object.assign(this.proxy.dataset, {discount:String(rate), total:this.money(prices.total) + ' ' + this.dataset.currency, bars:String(q * pieces), squares:String(q * pieces), perBar:perPiece, perSquare:perPiece});
      const hidden = this.form?.querySelector('[data-pdp2-quantity],[data-elite2-form-quantity],[data-c2hero-form-quantity],[data-zq-form-quantity]');
      if (hidden && !this.closest('[hidden]')) hidden.value = String(q);
      if (!this.closest('[hidden]')) this.proxy.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }
  customElements.define('zentein-quantity', ZenteinQuantity);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zentein-social"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zentein-wild')) {
  class ZenteinWild extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.trackNode = this.querySelector('.zw-track');
      this.allItems = [...this.querySelectorAll('[data-zw-item]')];
      this.carouselItems = [...this.trackNode.querySelectorAll('[data-zw-item]')];
      this.railItems = [...this.querySelectorAll('.zw-story-library [data-zw-item]')];
      this.progress = this.querySelector('[data-zw-progress]');
      this.hoverPointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.items = this.carouselItems;
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('.zw-modal__body');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = -1;
      this.played = new Set();
      this.viewed = false;
      this.listen(this, 'click', e => this.onClick(e));
      if (this.dataset.mode === 'early' || this.dataset.mode === 'full') {
        this.carouselItems.forEach(card => {
          this.listen(card, 'pointerenter', e => {
            if (e.pointerType === 'mouse' && this.hoverPointer.matches && !this.reduced.matches && !this.dialog.open) {
              this.stopPreview();
              this.previewTimer = setTimeout(() => this.startPreview(card), 140);
            }
          });
          this.listen(card, 'pointerleave', () => this.stopPreview());
        });
        this.listen(window, 'scroll', () => this.stopPreview(), {passive:true});
        this.listen(this.reduced, 'change', () => this.stopPreview());
      }
      this.listen(this.dialog, 'close', () => this.closed());
      this.listen(this.dialog, 'click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      });
      this.listen(this.dialog, 'keydown', e => {
        if (e.key === 'Tab') {
          const controls = [...this.dialog.querySelectorAll('button:not(:disabled), a[href], video[controls], [tabindex]:not([tabindex="-1"])')]
            .filter(node => !node.hidden && node.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
          return;
        }
        if (e.target.closest('video')) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.open(this.index + (e.key === 'ArrowLeft' ? -1 : 1), false);
        }
      });
      this.listen(this.trackNode, 'keydown', e => {
        if (e.target !== this.trackNode) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.scroll(e.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.listen(this.body, 'pointerdown', e => {
        this.swipe = null;
        if (e.pointerType !== 'touch' || !e.target.closest('.zw-modal__media')) return;
        const media = this.body.querySelector('.zw-modal__media').getBoundingClientRect();
        if (e.clientY > media.bottom - 65) return;
        this.swipe = {x:e.clientX, y:e.clientY};
      }, {passive:true});
      this.listen(this.body, 'pointerup', e => {
        if (!this.swipe) return;
        const dx = e.clientX - this.swipe.x, dy = e.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.open(this.index + (dx < 0 ? 1 : -1), false);
      }, {passive:true});
      this.listen(this.body, 'pointercancel', () => { this.swipe = null; }, {passive:true});
      this.listen(this.trackNode, 'scroll', () => this.arrows(), { passive: true });
      this.listen(window, 'resize', () => this.arrows(), { passive: true });
      this.listen(document, 'visitorConsentCollected', () => this.maybeViewed());
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) { this.stopPreview(); this.body.querySelector('video')?.pause(); }
        else this.refreshAvailability();
      });
      this.refreshAvailability(); this.arrows();
      this.timer = setInterval(() => this.refreshAvailability(), 30000);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(e => e.isIntersecting);
        if (!this.inView) this.stopPreview();
        this.maybeViewed();
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.stopPreview();
      this.abort?.abort(); clearInterval(this.timer); this.observer?.disconnect();
      this.initialized = false;
    }
    listen(target, name, fn, options = {}) { target.addEventListener(name, fn, { ...options, signal: this.abort.signal }); }
    canTrack() {
      return this.dataset.track === 'true' && this.dataset.designMode !== 'true' &&
        !new URLSearchParams(location.search).has('social_qa') &&
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    }
    event(name, item, extra = {}) {
      if (!this.canTrack()) return false;
      const detail = {
        section: this.dataset.mode === 'early' ? 'early_community' : this.dataset.mode === 'pdp' ? 'pdp_community' : 'zentein_in_the_wild', ...(this.dataset.currentProduct ? {product_id:this.dataset.currentProduct} : {}), content_id: item?.dataset.zwItem || null,
        creator_type: item?.dataset.creatorType || null, content_type: item?.dataset.kind || null, source_type: item?.dataset.sourceType || null,
        product_ids: item?.dataset.productIds?.split(',').filter(Boolean) || [],
        carousel_position: item ? Number(item.dataset.position) : null, ...extra
      };
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish !== 'function') return false;
        const surfaceEvents = { social_section_viewed: 'viewed', social_item_clicked: 'item_clicked', social_video_played: 'video_played' };
        const mode = this.dataset.mode;
        const eventName = (mode === 'early' || mode === 'pdp') && surfaceEvents[name] ? mode + '_community_' + surfaceEvents[name] : name;
        const result = publish.call(window.Shopify.analytics, eventName, detail);
        result?.catch?.(() => {});
        return true;
      } catch { return false; }
    }
    maybeViewed() {
      if (this.inView && !this.viewed) this.viewed = this.event('social_section_viewed', null, { item_count: this.carouselItems.length, rail_count: this.railItems.length });
    }
    onClick(e) {
      const group = e.target.closest('[data-zw-group]');
      if (group) {
        this.storyGroup = group;
        this.items = this.railItems.filter(item => item.dataset.storyGroup === group.dataset.zwGroup);
        this.returnFocus = group;
        const storyStart = Number(group.dataset.zwStoryStart || 0);
        this.event('social_item_clicked', this.items[storyStart], {surface:'story_group',group:group.dataset.groupTitle});
        this.open(storyStart, true); return;
      }
      const segment = e.target.closest('[data-zw-segment]');
      if (segment) { this.open(Number(segment.dataset.zwSegment), false); return; }
      const opener = e.target.closest('[data-zw-open], [data-zw-moment]');
      if (opener) {
        const item = opener.closest('[data-zw-item]') || this.items.find(i => i.dataset.zwItem === opener.dataset.zwMoment);
        if (!item) return;
        this.storyGroup = null;
        this.items = this.carouselItems;
        this.returnFocus = opener;
        this.event('social_item_clicked', item, { surface: opener.hasAttribute('data-zw-moment') ? 'rail' : 'carousel' });
        this.open(this.items.indexOf(item), true); return;
      }
      if (e.target.closest('[data-zw-close]')) this.dialog.close();
      if (e.target.closest('[data-zw-next]')) this.open(this.index + 1, false);
      if (e.target.closest('[data-zw-prev]')) this.open(this.index - 1, false);
      const scroll = e.target.closest('[data-zw-scroll]');
      if (scroll) this.scroll(Number(scroll.dataset.zwScroll));
      const product = e.target.closest('[data-zw-product]');
      if (product) this.event('social_product_clicked', this.items[this.index], { product_id: product.dataset.zwProduct });
      if (e.target.closest('[data-zw-instagram]')) this.event('social_instagram_clicked', this.items[this.index], { destination: 'original' });
      if (e.target.closest('[data-zw-follow]')) this.event('social_instagram_clicked', null, { destination: 'profile' });
    }
    scroll(direction) {
      const current = this.trackNode.scrollLeft;
      const origin = this.trackNode.getBoundingClientRect().left;
      const positions = this.carouselItems.map(card => card.getBoundingClientRect().left - origin + current - 6);
      const target = direction > 0 ? positions.find(left => left > current + 8) : positions.reverse().find(left => left < current - 8);
      this.trackNode.scrollTo({left:target ?? (direction > 0 ? this.trackNode.scrollWidth : 0),behavior:this.reduced.matches ? 'instant' : 'smooth'});
    }
    arrows() {
      const max = this.trackNode.scrollWidth - this.trackNode.clientWidth;
      this.querySelector('[data-zw-scroll="-1"]').disabled = this.trackNode.scrollLeft <= 2;
      this.querySelector('[data-zw-scroll="1"]').disabled = this.trackNode.scrollLeft >= max - 2;
      this.querySelector('.zw-footer').hidden = max <= 2;
    }
    startPreview(card) {
      if (this.reduced.matches || !this.hoverPointer.matches || this.dialog.open || !card.matches(':hover')) return;
      document.querySelectorAll('zentein-wild').forEach(other => other.stopPreview?.());
      const template = card.querySelector('[data-zw-preview]');
      if (!template) return;
      const video = template.content.querySelector('video').cloneNode(true);
      this.previewCard = card; this.previewVideo = video;
      video.className = 'zw-preview'; video.muted = true;
      video.addEventListener('playing', () => {
        if (this.previewVideo === video) { video.classList.add('is-playing'); card.classList.add('is-previewing'); }
      }, {once:true});
      video.addEventListener('error', () => { if (this.previewVideo === video) this.stopPreview(); }, {once:true});
      card.querySelector('.zw-card__media').append(video);
      video.src = video.dataset.src;
      video.play().catch(() => { if (this.previewVideo === video) this.stopPreview(); });
    }
    stopPreview() {
      clearTimeout(this.previewTimer);
      if (this.previewVideo) { this.previewVideo.pause(); this.previewVideo.removeAttribute('src'); this.previewVideo.load(); this.previewVideo.remove(); }
      this.previewCard?.classList.remove('is-previewing');
      this.previewVideo = null; this.previewCard = null;
    }
    renderProgress() {
      this.progress.replaceChildren();
      this.progress.hidden = !this.storyGroup;
      this.dialog.classList.toggle('zw-modal--stories', Boolean(this.storyGroup));
      this.querySelector('.zw-modal__brand>span').textContent = this.storyGroup?.dataset.groupTitle || this.dataset.viewerLabel;
      if (!this.storyGroup) return;
      this.items.forEach((item, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.zwSegment = i;
        button.setAttribute('aria-label', this.dataset.segmentLabel.replace('__NUMBER__', String(i + 1)));
        if (i === this.index) button.setAttribute('aria-current', 'true');
        const fill = document.createElement('span'); fill.style.width = i < this.index ? '100%' : '0%';
        button.append(fill); this.progress.append(button);
      });
    }
    disposeMedia() {
      const video = this.body.querySelector('video');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
      this.body.replaceChildren();
    }
    open(index, initial) {
      if (index < 0 || index >= this.items.length) return;
      document.querySelectorAll('zentein-wild').forEach(other => {
        other.stopPreview?.();
        if (other !== this && other.dialog?.open) other.dialog.close();
      });
      const previousVideo = this.body.querySelector('video');
      const keepMuted = !initial && Boolean(previousVideo?.muted);
      this.stopPreview(); this.disposeMedia(); this.index = index;
      const item = this.items[index];
      this.body.append(item.querySelector('[data-zw-template]').content.cloneNode(true));
      this.renderProgress();
      this.querySelector('[data-zw-position]').textContent = (index + 1) + ' / ' + this.items.length;
      this.querySelector('[data-zw-prev]').disabled = index === 0;
      this.querySelector('[data-zw-next]').disabled = index === this.items.length - 1;
      this.refreshModalStatus();
      this.body.scrollTop = 0;
      if (!this.dialog.open) {
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-zw-close]').focus({ preventScroll: true });
      }
      const video = this.body.querySelector('video');
      if (video) {
        video.addEventListener('playing', () => {
          if (!this.played.has(item.dataset.zwItem) && this.event('social_video_played', item)) this.played.add(item.dataset.zwItem);
        });
        video.addEventListener('error', () => {
          const message = this.body.querySelector('.zw-media-error');
          message.textContent = this.dataset.videoError; message.hidden = false;
        }, { once: true });
        video.muted = keepMuted;
        if (this.storyGroup) {
          video.addEventListener('timeupdate', () => {
            const fill = this.progress.children[index]?.firstElementChild;
            if (fill && Number.isFinite(video.duration) && video.duration > 0) fill.style.width = Math.min(100, video.currentTime / video.duration * 100) + '%';
          });
          video.addEventListener('ended', () => {
            if (this.index !== index || !this.dialog.open || document.hidden) return;
            if (index < this.items.length - 1 && !this.reduced.matches) this.open(index + 1, false);
            else if (index === this.items.length - 1) this.storyGroup?.classList.add('is-seen');
          }, {once:true});
        }
        video.src = video.dataset.src;
        video.play().catch(() => {});
      } else {
        this.body.querySelector('img')?.addEventListener('error', () => {
          this.body.querySelector('.zw-media-error').hidden = false;
        }, { once: true });
      }
      this.event('social_item_expanded', item);
    }
    closed() {
      this.stopPreview(); this.disposeMedia();
      if (this.oldOverflow !== undefined) document.documentElement.style.overflow = this.oldOverflow;
      this.returnFocus?.focus({ preventScroll: true }); this.index = -1;
    }
    active(item, now = Date.now()) {
      const start = Date.parse(item.dataset.storyPublished || item.dataset.published);
      const end = Date.parse(item.dataset.expires);
      return item.dataset.sourceType === 'Instagram Story' && item.dataset.storyStatus === 'Active' &&
        Number.isFinite(start) && Number.isFinite(end) && start <= now && end > now && end > start;
    }
    refreshAvailability() {
      if (this.dialog.open) this.refreshModalStatus();
    }
    refreshModalStatus() {
      const item = this.items[this.index]; if (!item) return;
      const link = this.body.querySelector('[data-zw-story-link]');
      if (link) link.hidden = !this.active(item);
    }
  }
  customElements.define('zentein-wild', ZenteinWild);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zentein-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const bar = document.querySelector('[data-zen-sticky-atc]');
      if (!bar || bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';

      const button = bar.querySelector('[data-zen-sticky-button]');
      const buttonLabel = bar.querySelector('[data-zen-sticky-button-label]');
      const selection = bar.querySelector('[data-zen-sticky-selection]');
      const variantWrap = bar.querySelector('[data-zen-sticky-variant-wrap]');
      const variantSelect = bar.querySelector('[data-zen-sticky-variant-select]');
      const fallbackForm = bar.querySelector('form');
      const fallbackId = bar.querySelector('[data-zen-sticky-fallback-id]');
      const fallbackQuantity = bar.querySelector('[data-zen-sticky-fallback-quantity]');
      const quantityControl = bar.querySelector('[data-zen-sticky-quantity-input]');
      const decrease = bar.querySelector('[data-zen-sticky-decrease]');
      const increase = bar.querySelector('[data-zen-sticky-increase]');
      const totalOutput = bar.querySelector('[data-zen-sticky-total]');
      const savingsOutput = bar.querySelector('[data-zen-sticky-savings]');
      const quantityNote = bar.querySelector('[data-zen-sticky-quantity-note]');
      const defaultQuantityNote = quantityNote.textContent;
      const main = document.getElementById('MainContent');
      const addLabel = bar.dataset.addLabel;
      const soldOutLabel = bar.dataset.soldOutLabel;
      const unavailableLabel = bar.dataset.unavailableLabel;
      const quantityLabel = bar.dataset.quantityLabel;
      const variantIds = new Set(variantSelect
        ? [...variantSelect.options].map((option) => option.value)
        : [fallbackId.value]);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: bar.dataset.currency || 'CAD'
      });
      const cartConfig = document.getElementById('ZenteinCartConfig');
      const initialCart = document.getElementById('ZenteinInitialCart');
      const rules = cartConfig ? JSON.parse(cartConfig.textContent).rules : null;
      const eligibleIds = new Set(rules?.eligibleProductIds || []);
      const eligibleCount = (cart) => (cart?.items || []).reduce((count, line) => {
        const properties = line.properties || {};
        return count + (eligibleIds.has(String(line.product_id)) &&
          !['paid', 'reward'].includes(properties._byb_role) &&
          properties._zlab_role !== 'gift' ? Number(line.quantity) || 0 : 0);
      }, 0);
      let cartEligibleQuantity = eligibleCount(initialCart ? JSON.parse(initialCart.textContent) : null);
      let pending = false;
      let invalidEntry = false;
      let currentQuantity = Math.max(1, Number(fallbackQuantity.value) || 1);
      let currentRule = { min: 1, max: Infinity, step: 1 };

      const primaryForm = () => {
        const selectors = [
          '[data-pdp2-primary-form] form',
          '[data-elite2-product-form] form',
          '[data-c2hero-product-form] form',
          'product-info product-form form[data-type="add-to-cart-form"]',
          'product-form form[data-type="add-to-cart-form"]',
          'form.zen-product-form',
          'form[action*="/cart/add"]'
        ];
        for (const selector of selectors) {
          const form = [...(main?.querySelectorAll(selector) || [])].find((candidate) =>
            !candidate.classList.contains('installment') &&
            !candidate.closest('[data-pdp2-cross-sell-form], .product-recommendations, [data-related-products]') &&
            (candidate.closest('[data-pdp2-primary-form], [data-elite2-product-form], [data-c2hero-product-form]') ||
              variantIds.has(candidate.querySelector('[name="id"]')?.value)) &&
            !!candidate.querySelector('button[type="submit"]')
          );
          if (form) return form;
        }
        return null;
      };

      const quantityField = (form) => form?.querySelector('[name="quantity"]') ||
        (form?.id ? document.querySelector('[name="quantity"][form="' + CSS.escape(form.id) + '"]') : null);

      const nativeQuantityWidget = (form) => {
        const widgets = [...(main?.querySelectorAll('zentein-quantity') || [])]
          .filter((widget) => !widget.closest('[hidden]'));
        return widgets.find((widget) => widget.dataset.formId === form?.id) ||
          widgets.find((widget) => widget.closest('[data-pdp2-root], [data-elite2-root], [data-c2hero-root]'));
      };

      const variantData = (variantId) => variantSelect?.querySelector('option[value="' + CSS.escape(variantId) + '"]');

      const ruleFor = (field, variant) => {
        const widget = field?.closest('zentein-quantity');
        const rawMin = field?.getAttribute('min') || widget?.min || field?.dataset.min || variant?.dataset.min || bar.dataset.defaultMin;
        const rawMax = field?.getAttribute('max') || field?.getAttribute('aria-valuemax') || widget?.max || field?.dataset.max || variant?.dataset.max || bar.dataset.defaultMax;
        const rawStep = field?.getAttribute('step') || widget?.step || field?.dataset.step || variant?.dataset.step || bar.dataset.defaultStep;
        return {
          min: Math.max(1, Number(rawMin) || 1),
          max: rawMax ? Number(rawMax) : Infinity,
          step: Math.max(1, Number(rawStep) || 1)
        };
      };

      const quantityAllowed = (value, rule) => Number.isInteger(value) &&
        value >= rule.min && value <= rule.max && (value - rule.min) % rule.step === 0;

      const unitPriceFor = (variant, sellingPlan) => {
        const regular = Number(variant?.dataset.priceCents || bar.dataset.defaultPriceCents) || 0;
        if (!sellingPlan) return regular;
        const prices = (variant?.dataset.planPrices || bar.dataset.defaultPlanPrices || '').split(',');
        const selected = prices.find((entry) => entry.split(':')[0] === sellingPlan);
        return selected ? Number(selected.split(':')[1]) || regular : regular;
      };

      const updatePrice = (quantity, variant, sellingPlan) => {
        const subtotal = unitPriceFor(variant, sellingPlan) * quantity;
        const eligibleTotal = cartEligibleQuantity + quantity;
        const percent = bar.dataset.quantitySavings === 'true'
          ? (rules?.quantityTiers || []).reduce((rate, tier) =>
              eligibleTotal >= Number(tier.minimum) ? Math.max(rate, Number(tier.percentage) || 0) : rate, 0)
          : 0;
        const savings = Math.round(subtotal * percent / 100);
        totalOutput.textContent = money.format((subtotal - savings) / 100);
        if (savingsOutput) savingsOutput.textContent = percent
          ? bar.dataset.saveLabel.replace('{amount}', money.format(savings / 100)).replace('{percent}', String(percent))
          : bar.dataset.startSavingsLabel;
        return subtotal - savings;
      };

      const setQuantity = (value) => {
        if (!quantityAllowed(value, currentRule)) return;
        const form = primaryForm();
        const nativeInput = nativeQuantityWidget(form)?.querySelector('[data-zq-input]');
        const nativeTier = main?.querySelector('[data-zen-tier="' + value + '"]');
        if (nativeInput && !nativeInput.disabled) {
          nativeInput.value = String(value);
          nativeInput.dispatchEvent(new Event('input', { bubbles: true }));
          nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (nativeTier && !nativeTier.disabled) nativeTier.click();
        else if (form) {
          let field = quantityField(form);
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'quantity';
            form.append(field);
          }
          field.value = String(value);
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          const offer = field.closest('[data-zen-offer]');
          if (offer) {
            offer.querySelectorAll('[data-zen-tier]').forEach((tier) => {
              const active = Number(tier.dataset.zenTier) === value;
              tier.classList.toggle('is-selected', active);
              tier.setAttribute('aria-pressed', String(active));
            });
            const submit = offer.querySelector('[data-zen-submit]');
            if (submit && !submit.disabled) submit.textContent = value === 1
              ? submit.dataset.zenSingleLabel
              : addLabel + ' · ' + value;
          }
        } else fallbackQuantity.value = String(value);
        currentQuantity = value;
        invalidEntry = false;
        quantityControl.value = String(value);
        quantityControl.removeAttribute('aria-invalid');
        quantityNote.textContent = defaultQuantityNote;
        schedule();
      };

      const update = () => {
        pending = false;
        const form = primaryForm();
        const nativeButton = form?.querySelector('button[type="submit"][name="add"], button[type="submit"]');
        const nativeId = form?.querySelector('[name="id"]');
        const variantId = nativeId?.value || variantSelect?.value || fallbackId.value;
        const variant = variantData(variantId);
        const nativeQuantity = quantityField(form);
        const widgetInput = nativeQuantityWidget(form)?.querySelector('[data-zq-input]');
        const quantity = Math.max(1, Number(widgetInput?.value || nativeQuantity?.value || fallbackQuantity.value) || 1);
        const sellingPlan = form?.querySelector('[name="selling_plan"]:not(:disabled)')?.value;
        const available = form
          ? !!nativeButton && !nativeButton.disabled && !!variantId && !nativeId?.disabled
          : !!fallbackId.value && (!variant || !variant.disabled);

        currentRule = ruleFor(widgetInput || nativeQuantity, variant);
        quantityControl.min = String(currentRule.min);
        quantityControl.step = String(currentRule.step);
        quantityControl.max = Number.isFinite(currentRule.max) ? String(currentRule.max) : '';
        if (!invalidEntry && !quantityAllowed(quantity, currentRule)) {
          setQuantity(currentRule.min);
          return;
        }
        currentQuantity = quantity;
        if (!invalidEntry) {
          quantityControl.value = String(quantity);
          quantityControl.removeAttribute('aria-invalid');
        }
        decrease.disabled = quantity <= currentRule.min;
        increase.disabled = quantity + currentRule.step > currentRule.max;
        const estimatedTotal = updatePrice(quantity, variant, sellingPlan);

        if (variantWrap) variantWrap.hidden = !!form;
        const parts = [];
        const variantTitle = variant?.dataset.title || bar.dataset.defaultTitle;
        if (variantTitle && variantTitle !== 'Default Title') parts.push(variantTitle);
        if (quantity > 1 || sellingPlan) parts.push(quantityLabel + ' ' + quantity);
        else parts.push(money.format(estimatedTotal / 100));
        selection.textContent = parts.join(' · ');
        button.disabled = !available || invalidEntry || !quantityAllowed(quantity, currentRule);
        buttonLabel.textContent = available ? addLabel : (variantId ? soldOutLabel : unavailableLabel);

        const passed = nativeButton
          ? nativeButton.getBoundingClientRect().bottom < 0
          : window.scrollY > 220;
        const show = passed && !!(form || fallbackId.value);
        bar.hidden = false;
        bar.classList.toggle('is-visible', show);
        bar.inert = !show;
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.add('zen-sticky-ready');
        document.body.classList.toggle('zen-sticky-visible', show);
        document.documentElement.style.setProperty('--zen-sticky-atc-height', bar.offsetHeight + 'px');
      };

      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      };

      button.addEventListener('click', () => {
        const form = primaryForm();
        const nativeButton = form?.querySelector('button[type="submit"][name="add"], button[type="submit"]');
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
        else if (!form && !button.disabled) fallbackForm.requestSubmit();
        schedule();
      });
      decrease.addEventListener('click', () => setQuantity(Math.max(currentRule.min, currentQuantity - currentRule.step)));
      increase.addEventListener('click', () => setQuantity(currentQuantity + currentRule.step));
      quantityControl.addEventListener('input', () => {
        const value = Number(quantityControl.value);
        if (quantityControl.value === '' || !quantityAllowed(value, currentRule)) {
          invalidEntry = true;
          quantityControl.setAttribute('aria-invalid', 'true');
          quantityNote.textContent = bar.dataset.invalidQuantityLabel;
          button.disabled = true;
          return;
        }
        setQuantity(value);
      });
      quantityControl.addEventListener('change', () => {
        if (!invalidEntry) return;
        invalidEntry = false;
        quantityControl.removeAttribute('aria-invalid');
        quantityControl.value = String(currentQuantity);
        quantityNote.textContent = defaultQuantityNote;
        schedule();
      });
      variantSelect?.addEventListener('change', () => {
        fallbackId.value = variantSelect.value;
        schedule();
      });
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      main?.addEventListener('input', schedule, true);
      main?.addEventListener('change', schedule, true);
      main?.addEventListener('variant:change', schedule, true);
      document.addEventListener('zentein:cart:confirmed', (event) => {
        cartEligibleQuantity = eligibleCount(event.detail?.cart);
        schedule();
      });
      if (main) {
        new MutationObserver(schedule).observe(main, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled', 'value']
        });
      }
      new ResizeObserver(schedule).observe(bar);
      update();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zlab-grow-garden"] && !Shopify.designMode) return;
  try {
    function initZGarden(scope) {
  scope.querySelectorAll('[data-zgarden]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const copy=JSON.parse(root.querySelector('[data-zg-copy]').textContent);
    let stage=0, rabbit=false, eaten=false, timers=[];
    const next=root.querySelector('[data-zg-next]');
    const message=root.querySelector('[data-zg-rabbit-message]');
    const reset=root.querySelector('[data-zg-reset]');
    const render=()=> {
      root.dataset.stage=String(stage);
      root.style.setProperty('--zg-progress',`${stage/6*100}%`);
      root.querySelector('[data-zg-progress]').textContent=copy.progress.replace('[step]',stage);
      root.querySelectorAll('[data-zg-panel]').forEach(p=>p.hidden=eaten||Number(p.dataset.zgPanel)!==stage);
      message.hidden=!eaten;
      root.querySelectorAll('[data-zg-step]').forEach(b=>{
        const step=Number(b.dataset.zgStep);
        b.setAttribute('aria-pressed',String(step===stage));
        b.classList.toggle('is-complete',step<=stage);
        b.classList.toggle('is-next',!rabbit&&step===stage+1);
        b.disabled=rabbit||step!==stage+1;
      });
      next.hidden=stage===6;
      next.disabled=rabbit;
      next.textContent=(stage===0?copy.start:copy.steps[stage])+' →';
      reset.hidden=stage===0;
      reset.disabled=rabbit;
      root.querySelector('[data-zg-complete]').hidden=stage!==6||rabbit;
    };
    const advance=()=>{
      if(rabbit||stage>=6)return;
      eaten=false;root.classList.remove('is-eaten');stage++;render();
      if(stage===6)reset.focus();
    };
    root.querySelectorAll('[data-zg-step]').forEach(b=>b.addEventListener('click',()=>{
      if(Number(b.dataset.zgStep)===stage+1)advance();
    }));
    next.addEventListener('click',advance);
    reset.addEventListener('click',()=>{if(rabbit)return;stage=0;eaten=false;root.classList.remove('is-eaten');render();next.focus();});
    root.querySelector('[data-zg-rabbit]').addEventListener('click',()=>{
      timers.forEach(clearTimeout);timers=[];
      const hadPlant=stage>0;
      rabbit=true;
      root.querySelector('[data-zg-rabbit-copy]').textContent=hadPlant?copy.rabbit:copy.rabbitSeed;
      root.classList.remove('is-rabbit');
      void root.offsetWidth;
      root.classList.add('is-rabbit');
      render();
      timers.push(setTimeout(()=>{eaten=true;stage=0;root.classList.add('is-eaten');render();},1100));
      timers.push(setTimeout(()=>{rabbit=false;root.classList.remove('is-rabbit');render();},2050));
    });
    render();
  });
}
initZGarden(document);
document.addEventListener('shopify:section:load',e=>initZGarden(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zlab-powder-offer"] && !Shopify.designMode) return;
  try {
    function initZPowder(scope) {
  scope.querySelectorAll('[data-zpowder]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const copy = JSON.parse(root.querySelector('[data-zp-copy]').textContent);
    const rows = [...root.querySelectorAll('[data-zp-flavour]')];
    const counts = Object.fromEntries(rows.map(row => [row.dataset.zpFlavour, 0]));
    const singles = root.querySelector('[data-zp-single]');
    const bundleButton = root.querySelector('[data-zp-checkout]');
    const labels = new Map([singles, bundleButton].map(button => [button, button.textContent]));
    const variants = {superfood: Number(root.dataset.superfoodVariant), lions: Number(root.dataset.lionsVariant)};
    const bundleEnabled = root.dataset.bundleEnabled === 'true';
    const available = Object.values(variants).every(id => Number.isSafeInteger(id) && id > 0);
    const route = (copy.rootUrl || '/').replace(/\/?$/, '/');
    let saving = false;
    const total = () => Object.values(counts).reduce((a, b) => a + b, 0);
    const feedback = text => root.querySelectorAll('[data-zp-feedback]').forEach(node => { node.textContent = text; node.hidden = !text; });
    const render = () => {
      const n = total();
      const choices = rows.flatMap(row => Array(counts[row.dataset.zpFlavour]).fill(row.dataset.name));
      rows.forEach(row => {
        const qty = counts[row.dataset.zpFlavour];
        row.querySelector('output').textContent = qty;
        row.querySelector('[data-zp-minus]').disabled = saving || qty === 0;
        row.querySelector('[data-zp-plus]').disabled = saving || n >= 2;
      });
      root.querySelector('[data-zp-count]').textContent = copy.count.replace('[count]', n);
      root.querySelectorAll('[data-zp-slot]').forEach((slot, i) => { slot.classList.toggle('is-filled', i < n); slot.querySelector('em').textContent = choices[i] || copy.empty; });
      bundleButton.disabled = saving || !available || !bundleEnabled || n !== 2;
      singles.disabled = saving || !available;
      root.querySelector('[data-zp-both]').disabled = saving || !available;
      root.querySelector('[data-zp-hint]').textContent = !bundleEnabled ? copy.bundlePending : n === 2 ? copy.ready : copy.remaining.replace('[count]', 2 - n);
      try { sessionStorage.setItem('zlab-powder-gifts-2', JSON.stringify(counts)); } catch {}
    };
    try {
      const saved = JSON.parse(sessionStorage.getItem('zlab-powder-gifts-2') || '{}');
      if (Object.keys(saved).every(k => k in counts) && Object.values(saved).every(v => Number.isInteger(v) && v >= 0 && v <= 2) && Object.values(saved).reduce((a, b) => a + b, 0) <= 2) Object.assign(counts, saved);
    } catch {}
    rows.forEach(row => {
      const key = row.dataset.zpFlavour;
      row.querySelector('[data-zp-plus]').addEventListener('click', () => { if (!saving && total() < 2) counts[key]++; render(); });
      row.querySelector('[data-zp-minus]').addEventListener('click', () => { if (!saving) counts[key] = Math.max(0, counts[key] - 1); render(); });
    });
    root.querySelector('[data-zp-both]').addEventListener('click', () => root.querySelector('[data-zp-gift-title]').focus());
    const addToCart = async (bundle, trigger) => {
      if (saving || !available || (bundle && (!bundleEnabled || total() !== 2))) return;
      const group = 'ZP-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2));
      const items = bundle
        ? Object.values(variants).map(id => ({id, quantity: 1, properties: {_zlab_bundle_id: group, _zlab_role: 'powder'}}))
        : [{id: variants[root.dataset.powder], quantity: 1}];
      if (bundle) rows.forEach(row => {
        const quantity = counts[row.dataset.zpFlavour];
        if (quantity) items.push({id: Number(row.dataset.variantId), quantity, properties: {_zlab_bundle_id: group, _zlab_role: 'gift'}});
      });
      saving = true; feedback(''); render(); trigger.textContent = copy.working;
      try {
        const response = await fetch(route + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: route + 'cart'})});
        const result = await response.json().catch(() => null);
        if (!response.ok) throw new Error(result?.description || result?.message || copy.error);
        if (window.ZenteinCart) { window.ZenteinCart.open(trigger); return; }
        const drawer = document.querySelector('cart-drawer');
        try {
          if (!drawer?.renderContents) throw new Error('Cart drawer unavailable');
          if (!result?.sections?.['cart-drawer'] || !result?.sections?.['cart-icon-bubble']) {
            const refresh = await fetch(route + 'cart?sections=cart-drawer,cart-icon-bubble', {headers: {Accept: 'application/json'}});
            result.sections = await refresh.json();
          }
          if (!result.sections['cart-drawer'] || !result.sections['cart-icon-bubble']) throw new Error('Cart display unavailable');
          drawer.setActiveElement(trigger);
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch {
          window.location.assign(route + 'cart');
        }
      } catch (error) {
        feedback(error.message || copy.error);
      } finally {
        saving = false; labels.forEach((label, button) => { button.textContent = label; }); render();
      }
    };
    singles.addEventListener('click', event => addToCart(false, event.currentTarget));
    bundleButton.addEventListener('click', event => addToCart(true, event.currentTarget));
    render();
    if (!available) feedback(copy.unavailable);
  });
}
initZPowder(document);
document.addEventListener('shopify:section:load', event => initZPowder(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zlab-serving-controls"] && !Shopify.designMode) return;
  try {
    function initZServing(scope) {
  scope.querySelectorAll('[data-zserving]').forEach(control=>{
    if(control.dataset.initialized)return;
    control.dataset.initialized='true';
    const root=control.closest('[data-spif-vitamins]');
    if(!root)return;
    const copy=JSON.parse(control.querySelector('[data-zn-copy]').textContent);
    // [amount at 0.5 g, display unit, Canadian daily reference amount]
    const vitamins={d:[7.2,'µg',20],a:[324,'µg RAE',900],c:[32.4,'mg',90],e:[5.4,'mg',15],b1:[0.43,'mg',1.2],b6:[0.61,'mg',1.7],b2:[0.47,'mg',1.3],niacin:[5.8,'mg NE',16],b5:[1.8,'mg',5],biotin:[10.8,'µg',30],folate:[144,'µg DFE',400],k:[42.3,'µg',120],b12:[0,'µg',2.4]};
    const macros={fat:[0.06,'g'],saturated:[0.01,'g'],trans:[0,'g'],cholesterol:[0,'mg'],sodium:[0.1,'mg','<'],potassium:[1.2,'mg'],carbohydrate:[0.2,'g'],fibre:[0.06,'g'],sugars:[0.01,'g'],protein:[0.05,'g']};
    const number=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(n);
    const render=amount=>{
      const factor=amount/0.5;
      root.querySelector('[data-zn-serving]').textContent=copy.serving.replace('[amount]',number(amount));
      root.querySelector('[data-zn-calories]').textContent=number(1.5*factor);
      root.querySelectorAll('[data-zn-macro]').forEach(el=>{
        const [value,unit,prefix='']=macros[el.dataset.znMacro];
        el.textContent=prefix+number(value*factor)+' '+unit;
      });
      root.querySelectorAll('[data-zn-vitamin]').forEach(el=>{
        const key=el.dataset.znVitamin,[value,unit]=vitamins[key];
        el.textContent=key==='b12'?copy.missing:number(value*factor)+' '+unit;
      });
      root.querySelectorAll('[data-zn-dv]').forEach(el=>{
        const [value,,reference]=vitamins[el.dataset.znDv];
        el.textContent=copy.dv.replace('[value]',Math.round(value*factor/reference*100));
      });
      control.querySelector('[data-zn-announce]').textContent=copy.update.replace('[amount]',number(amount));
    };
    control.querySelectorAll('input[type=radio]').forEach(input=>input.addEventListener('change',()=>{if(input.checked)render(Number(input.value));}));
    render(Number(control.querySelector('input:checked').value));
  });
}
initZServing(document);
document.addEventListener('shopify:section:load',e=>initZServing(e.target));
  } catch(e) { console.error(e); }
})();

})();
